import { getObjectFromStorage } from '../../../services/LocalStorage';

export const JUST_LAUNCHED_LOCAL_STORAGE_KEY = 'JustLaunchedLink';
const ONE_DAY = 24 * 60 * 60 * 1000;

// E.g. `Date.parse('2026-01-27')` can be used to add an entry
const updateTimestampsAscOrdered: number[] = [Date.parse('2026-01-26')];

export const hasUpdateJustLaunched = (updateTimestamps: number[], now: number, lastVisited: number) =>
    updateTimestamps.some(t => t > lastVisited && t <= now);

export const hasUpdateJustLaunchedIO = () => {
    const state = getObjectFromStorage(JUST_LAUNCHED_LOCAL_STORAGE_KEY, { lastVisit: 0 });
    return hasUpdateJustLaunched(updateTimestampsAscOrdered, Date.now(), state.lastVisit);
};

export const shouldShowJustLaunched = (updateTimestamps: number[], now: number, lastVisited: number) =>
    now - lastVisited < ONE_DAY || hasUpdateJustLaunched(updateTimestamps, now, lastVisited);

export const shouldShowJustLaunchedIO = () => {
    const state = getObjectFromStorage(JUST_LAUNCHED_LOCAL_STORAGE_KEY, { lastVisit: 0 });
    return shouldShowJustLaunched(updateTimestampsAscOrdered, Date.now(), state.lastVisit);
};
